import { Component, OnInit, Input } from '@angular/core';
import { DemandReductionStation } from 'src/app/services/demand-reduction-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-demand-notes-button',
  templateUrl: './demand-notes-button.component.html',
  styleUrls: ['./demand-notes-button.component.scss']
})
export class DemandNotesButtonComponent implements OnInit {

  @Input() station: DemandReductionStation;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-notes'});
  }

}
